var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1960_89358)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4982,
    cy: 20,
    rx: 19.9984,
    ry: 20,
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8305 14.2389C19.0528 13.1473 20.0241 12.375 21.1368 12.375H23.8595C24.9722 12.375 25.9435 13.1473 26.1659 14.2389C26.2172 14.4909 26.4454 14.6757 26.6828 14.6757H26.6965L26.7102 14.6763C27.8796 14.7274 28.7778 14.871 29.5278 15.363C30.0002 15.673 30.4066 16.0718 30.7234 16.5372C31.1174 17.1162 31.2911 17.7808 31.3745 18.5845C31.4558 19.3698 31.4558 20.3542 31.4558 21.6009V21.6718C31.4558 22.9186 31.4558 23.9029 31.3745 24.6882C31.2911 25.4919 31.1174 26.1565 30.7234 26.7355C30.4066 27.2009 30.0002 27.5998 29.5278 27.9097C28.9416 28.2943 28.2695 28.4639 27.4544 28.5453C26.6564 28.625 25.6554 28.625 24.3842 28.625H20.6121C19.3409 28.625 18.3399 28.625 17.5418 28.5453C16.7268 28.4639 16.0548 28.2943 15.4686 27.9097C14.9961 27.5998 14.5897 27.2009 14.273 26.7355C13.8789 26.1565 13.7051 25.4919 13.6219 24.6882C13.5405 23.9029 13.5405 22.9186 13.5405 21.6718V21.6009C13.5405 20.3542 13.5405 19.3698 13.6219 18.5845C13.7051 17.7808 13.8789 17.1162 14.273 16.5372C14.5897 16.0718 14.9961 15.673 15.4686 15.363C16.2185 14.871 17.1167 14.7274 18.2862 14.6763L18.2998 14.6757H18.3135C18.5509 14.6757 18.7791 14.4909 18.8305 14.2389ZM21.1368 13.625C20.6027 13.625 20.1559 13.9942 20.0552 14.4884C19.8922 15.2888 19.1826 15.9182 18.3288 15.9256C17.205 15.9756 16.6031 16.1136 16.1542 16.4081C15.8179 16.6288 15.53 16.9117 15.3063 17.2405C15.0762 17.5786 14.9379 18.011 14.8651 18.7134C14.7912 19.4267 14.7904 20.3463 14.7904 21.6363C14.7904 22.9264 14.7912 23.846 14.8651 24.5593C14.9379 25.2617 15.0762 25.6941 15.3063 26.0323C15.53 26.361 15.8179 26.644 16.1542 26.8646C16.5021 27.0928 16.9473 27.2297 17.6661 27.3015C18.3947 27.3743 19.3333 27.375 20.6465 27.375H24.3498C25.663 27.375 26.6016 27.3743 27.3303 27.3015C28.0491 27.2297 28.4942 27.0928 28.8422 26.8646C29.1784 26.644 29.4664 26.361 29.69 26.0323C29.9202 25.6941 30.0584 25.2617 30.1312 24.5593C30.2051 23.846 30.2059 22.9264 30.2059 21.6363C30.2059 20.3463 30.2051 19.4267 30.1312 18.7134C30.0584 18.011 29.9202 17.5786 29.69 17.2405C29.4664 16.9117 29.1784 16.6288 28.8422 16.4081C28.3932 16.1136 27.7913 15.9756 26.6676 15.9256C25.8137 15.9182 25.1041 15.2888 24.9411 14.4884C24.8404 13.9942 24.3937 13.625 23.8595 13.625H21.1368ZM22.4982 19.4583C21.4627 19.4583 20.6233 20.2978 20.6233 21.3333C20.6233 22.3688 21.4627 23.2083 22.4982 23.2083C23.5336 23.2083 24.373 22.3688 24.373 21.3333C24.373 20.2978 23.5336 19.4583 22.4982 19.4583ZM19.3734 21.3333C19.3734 19.6074 20.7724 18.2083 22.4982 18.2083C24.2239 18.2083 25.6229 19.6074 25.6229 21.3333C25.6229 23.0592 24.2239 24.4583 22.4982 24.4583C20.7724 24.4583 19.3734 23.0592 19.3734 21.3333ZM26.8728 18.8333C26.8728 18.4882 27.1526 18.2083 27.4978 18.2083H28.331C28.6762 18.2083 28.956 18.4882 28.956 18.8333C28.956 19.1785 28.6762 19.4583 28.331 19.4583H27.4978C27.1526 19.4583 26.8728 19.1785 26.8728 18.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1960_89358",
    x: 0.499756,
    y: 0,
    width: 43.9968,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1960_89358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1960_89358",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraicon);
export default __webpack_public_path__ + "static/media/Camera icon.bf9faab3efb0a630c33222b2ef221824.svg";
export { ForwardRef as ReactComponent };